const CURRENCY_SYMBOLS: Record<string, string> = {
  CZK: 'Kč',
  EUR: '€',
  USD: '$',
  GBP: '£',
  PLN: 'zł',
  HUF: 'Ft',
  RON: 'lei',
  BGN: 'лв',
};

/**
 * Formats a product price with its feed currency. Falls back to the Czech
 * koruna when the feed omits a currency (the historical default), and to the
 * raw ISO code for currencies without a known symbol. Returns `null` for a
 * missing price so callers can skip rendering.
 */
export function formatPrice(
  price: number | null | undefined,
  currency?: string | null,
): string | null {
  if (price === null || price === undefined) {
    return null;
  }

  const code = currency?.trim().toUpperCase();
  const symbol = code ? (CURRENCY_SYMBOLS[code] ?? code) : 'Kč';

  return `${price} ${symbol}`;
}
